import * as React from "react";
import DemoButtons from "./Utiilities/Buttonts";
import Onlydemobtn from "./Utiilities/Onlydemobtn"
import ImageSlider from "./Utiilities/ImageSlider";
import Plans from "./Utiilities/Plans";
import Accordion from "./Utiilities/AccordionItem";
import Lightbox from "./Utiilities/Lightbox";
import SpecailButtons from "./Utiilities/SpecialButtons";
import Footer from "./Header and Footer/Footer";
import Header from "./Header and Footer/Header";
import ScrollToTop from "./Utiilities/ScrolltoTop";
import G2Badge from "./Utiilities/G2Badge";
import TabsWithImage from "./Utiilities/TabsWithImage";
import Availability from "./Utiilities/Availability";
import OurClients from "./Utiilities/OurClients";
import Integration from "./Utiilities/Integration";
import { MyContext } from "../App";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useEffect, useState } from 'react';
import Azuer from "./Utiilities/Azuer";
import OverviewCommon from "./GlobalMultiple/OverviewCommonPM";
import CyberSecurity from "./Utiilities/CyberSecurity";

function PM365() {

  const PDF = require("../Assests/Images/PDF.pdf")
  const AppName = React.useContext(MyContext)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const tabs = [
    {
      id: 1, title: 'Appraisals', Heading: `Simplify Appraisals Using HR365 Performance Management Software`, content: (
        <ul>
          <li>
            Tailor appraisal cycles and rating scales in Microsoft Performance Management to match your objectives.
          </li>
          <li>
            Easily handle employee evaluations with our efficient performance management software.
          </li>
          <li>
            PM365 fosters a collaborative review environment for improved accuracy and efficiency.
          </li>
          <li>
            Built-in feedback tools enable real-time comments and multi-reviewer assessments for a thorough evaluation process.
          </li>

        </ul>
      ), image: 'https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/PM365/apprasalcycle_u9-4idRi8.gif?updatedAt=1720501713899'
    },
    {
      id: 2, title: 'Acknowledge', Heading: 'Evaluate and Acknowledge Employee Contributions', content: (
        <ul>
          <li>
            Boost evaluations with employee performance software featuring multi-reviewer assessments and weighted reviews for thorough feedback.
          </li>
          <li>
            Seamlessly integrates with HR365 HRMS or works standalone to streamline effective employee performance management.
          </li>
          <li>
            Customizable metrics and goals enable tailored evaluations aligned with individual and company objectives.
          </li>
          <li>
            In-depth reporting and analytics reveal performance trends, highlighting strengths and opportunities for growth.
          </li>

        </ul>
      ), image: 'https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/PM365/reports%20(1)_G0cISZOj08.gif?updatedAt=1720501713282'
    },
    {
      id: 3, title: '360-Degree', Heading: 'Comprehensive 360-Degree Feedback for Ongoing Improvement',
      content: (
        <ul>
          <li>
            Our HR performance management tool tracks employee growth and fosters constructive feedback exchange among peers, managers, and stakeholders.
          </li>
          <li>
            It enables a continuous feedback loop during appraisals and supports spontaneous, ad hoc feedback moments.
          </li>
          <li>
            Anonymous feedback options ensure honest, confidential input for more accurate and actionable insights.
          </li>

        </ul>
      ), image: 'https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/PM365/feedback_98syly-MO.gif?updatedAt=1720501713725'
    },
    {
      id: 4, title: 'Dashboards', Heading: 'Performance Dashboards: SharePoint Employee Management Tool', content: (
        <ul>
          <li>
            Streamline processes with employee performance software that automates reminders, creates reports, and sends notifications through email or Teams.
          </li>
          <li>
            The dashboard provides a clear snapshot of appraisal progress, reducing coordination efforts while HR365 manages follow-ups.
          </li>
          <li>
            Tailor the dashboard with customizable widgets and filters to highlight key performance metrics and trends.
          </li>
          <li>
            Real-time data syncing keeps all dashboard details up-to-date with the latest evaluation updates.
          </li>
        </ul>
      ),
      image: 'https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/PM365/dashboard_WeNdVZqIV.gif?updatedAt=1720501713940'
    },

  ];
  const planData = [
    {
      name: "Standard",
      price: "$79",
      sup: "99",
      text: "Standard Plan Features",
      textY: "per month, billed yearly",
      features: [
        "10 users",
        "2 support tickets per annum",
        "Free updates via MS store",
        "Integrates with Office 365",
        "SharePoint app only",
        "Data stays in SharePoint",
        "Multiple roles",
      ],
    },
    {
      name: "Plus",
      price: "$149",
      sup: "99",
      textY: "per month, billed yearly",
      text: "Everything in Standard and...",
      features: [
        "25 users",
        "4 support tickets per annum",
        "Free updates with support",
        "KRA Categories",
        "Custom Logo",
        "5 Point rating scale",
        "Notifications",
        "Multiple departments & groups",
        "Multiple appraisal cycles",
      ],
    },
    {
      name: "Premium",
      price: "$199",
      sup: "99",
      textY: "per month, billed yearly",
      text: "Everything in Plus, and...",
      features: [
        "40 users",
        "Additional users at $1.5/user",
        "Unlimited support tickets",
        "Microsoft Teams App",
        "Self-Review",
        "KRA bank",
        "KRA templates",
        "Weighted rating option",
        "Dashboard - Performance Analytics",
        "Rating to verbatims",
        "360 degree feedback module",
        "1:1 meeting tracker Module",
        "Smart notifications",
      ],
    },
    {
      name: "Enterprise",
      price: "$249",
      sup: "99",
      textY: "per month, billed yearly",
      text: "Everything in Premium and...",
      features: [
        "25 Users",
        "Additional users at $2/user",
        "Multiple Reviewers",
        "9 point enterprise rating scale",
        "Multiple rating scales options",
        "Collaboration timelines",
        "Dashboard - Org analytics",
        "1:1 Meetings on Calendar",
        "Customizable email notifications",
        "Customize with Power Automate",
        "Power BI & Power Apps Integration",
        "Dedicated Account Manager",
        "Integration with KRAs",
        "One free customization*",
      ],
    },
  ];
  const accordionItems = [
    {
      title: `1. What is Performance Management Software & Why Do You Need It? `,
      content:
        `It helps track employee performance, automate goal-setting, and simplify reviews. Our employee goal tracker can help you decrease paperwork, increase efficiency, and improve team productivity. `,
    },
    {
      title: `2. What Are the Key Benefits of Using Employee Performance Software? `,
      content: <ul>
        <li>Employee Performance Appraisal Software improves efficiency by automating performance tracking, feedback gathering, and evaluation procedures. </li>
        <li>It minimizes manual effort, improves accuracy, and delivers real-time insights, allowing managers to concentrate on employee development and strategic decision-making. </li>
        <li>Employee Performance Appraisal Software identifies top performers as well as areas for development, encouraging a culture of continual growth and productivity. </li>
        <li>It ensures fair appraisals, increases employee engagement, and improves workforce management. Investing in Employee Performance Software results in a more productive and motivated workforce.
        </li>
      </ul>
      ,
    },
    {
      title:
        `3. How Much Does Performance Management 365 Cost? `,
      content:
        `We offer flexible pricing to suit your team’s size and needs. Contact us for a quote.  `,
    },
    {
      title: `Which currency are the prices listed in?`, content: (
        "All prices are listed in USD."

      )
    },

    // {
    //   title: `4. Can I install multiple instances of Employee Performance Management 365?`,
    //   content: `Yes, you can install multiple instances of the application as long as it is in one Microsoft 365 tenant and total number of users of all the instances installed remain within the user limit as per your plan or license you purchased.`,
    // },
    // {
    //   title: `5. How ${AppName}'s Performance Management System differentiate?`,
    //   content: `Employee Performance Management Tools or employee feedback app enable clients to conduct a multi-dimensional assessment of their employees’ abilities, behavioural competencies, and performance. The analytics system will provide managers with the data, expertise, and tools they need to conduct a more constructive evaluation of their team.`,
    // }
  ];
  const [isLightboxOpen, setLightboxOpen] = React.useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = React.useState("");

  const openLightbox = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Boost Productivity with HR365 Performance Management Software</title>
          <meta name="description" content="Empower employees, track goals, and drive growth with HR365’s 360° feedback system. Integrated with Microsoft 365, it’s the key to unlocking peak performance." />
        </Helmet>
        <ScrollToTop />
        <Header />
        <div className="HR_panel">
          <div className="HR_FlexCenterSpcBetween HR_ParentSection1">
            <div className="HR_Section1LeftSide">
              <h1 className="HR_primaryclr  ">
                Achieve growth through Employee Performance Management 365
              </h1>
              <p className="HR_textclr">
                Stop wasting time on manual reviews! With Performance Management 365, streamline goal setting, OKR management, continuous feedback, and 360-degree reviews to unlock your team’s true potential. Identify top talent, close skill gaps, and drive results—all in one Employee Performance Management System.
              </p>
              {/* <Onlydemobtn /> */}
              <DemoButtons />
            </div>
            <div className="HR_Section1RightSide">
              {/* <img alt="MainImage" src={ImageSction1}   /> */}
              <img className="BannerImageStyles" alt="MainImage" src="https://ik.imagekit.io/zn4au2jftpm5/LP%20page/Vector%20verticale%20500%20(23)%20(1)_kauF-lfLe.png?updatedAt=1743518817958" />
            </div>
          </div>
        </div>
        {/* <GetOfferPage Type="Image"/> */}
        <div>
          <G2Badge
          // heading="Now Performance Management 365 App is Available on Microsoft Teams"
          // PM365badge={"PM365Badge"}
          // imageUrl="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/PM365_nLChfGaEs.png?updatedAt=1720507129448" 
          // videoUrl="https://www.youtube.com/watch?v=j5Y0ynOp_GA"
          />
          <OverviewCommon />
          <div className='cybersection' >
            <CyberSecurity />
          </div>
        </div>


        <div id="features" className="IdChanges"></div>
        <div >
          <TabsWithImage tabs={tabs} />
        </div>
        <div>
          <Availability />
        </div>
        <div id="client" className="IdChanges"></div>
        <div className='HR_whitesection' >
          <h2 className='HR_heading HR_MT' >Hear from Our Happy Customers
          </h2>

          <div className='HR_MT'>
            <OurClients />
          </div>
        </div>
        <div id="integration" className="IdChangesIntegration"></div>
        <div className='integartionPT'>
          <Integration appName={"Performance Management 365"} />
          {/* <Intigration/> */}

        </div>

        <div className="IdChangesIntegration"></div>



        <div className="HR_whitesection">
          <div className="HR_MT">

            <div>
              <h2 className='HR_heading HR_MT' id="pricing" >Performance Management 365 Plans
              </h2>
              <Plans plans={planData} appName={"Performance Management 365"} />
            </div>
          </div>
        </div>
        {/* <div className="Azuersection">
          <div className='AzureLogoText'>
            <a href='https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1' target='_blank'>
              <img className='AzureImage' src='https://ik.imagekit.io/zn4au2jftpm5/Azure_dQeGdjXNs_cWe2-VVEx.jpeg?updatedAt=1736158710879' alt='Azure' />
            </a>
            <p className='AzureText'>
              Using Azure? now you can <a href='https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1' target='_blank'>
                buy
              </a>
              on Azure Marketplace or using your enterprise agreement
            </p>
          </div> */}
        {/* <FormComponent /> */}
        {/* <SpecailButtons userCount={"500+"} />
          <h3 className='HR_heading1 HR_MT'>Get started with 14 days risk free trial. <br />No credit card details required
          </h3>
          <div className='Hr_flexpm HR_MT'>
            <DemoButtons /> */}
        {/* <a href={PDF} download="Performance Management 365.pdf">
            <button className="downloadnow">Download Now</button>
            </a> */}
        {/* </div> */}
        <Azuer userCount={"500+"} />
        {/* </div> */}


        {/* <div className="pmvideo">
            <h3 className='videotitle'> See It in Action – Watch a Demo Now!</h3>
            <PMvideo  videoId="j5Y0ynOp_GA" />
          </div> */}
        {/* <div className="Personalised">
            <div className="Personalisedone">
            <h3 className="personalisedtitle">Schedule a Free Personalised Demo or Free Trail</h3>
            <p className="personalisedp">Discover the full potential of our product with a complimentary trial today! </p>
            <DemoButtons/>
            </div>
            <div className="Personalisedtwo">
            <img className='personalimg' src='https://ik.imagekit.io/zn4au2jftpm5/Untitled%20design%20(3)%202%20(1)_UZpBvPU7A.png?updatedAt=1736170678886' alt='Azure' />
            </div>

          </div> */}
        <span className='privacytext'></span>
        <div id="faq" className="IdChangesIntegration"></div>
        <div className='HR_FAQ' >

          <div>
            <h3 className='HR_faq'>Frequently Asked Questions</h3>
            <Accordion items={accordionItems} />
          </div>



        </div>
        <Footer />
      </HelmetProvider>
    </>
  );
}
export default PM365;
